export default [
  //    - Booking details
  {
    path: '/bookings/:localizator',
    name: 'foravila-booking',
    component: () => import('@/views/foravila/bookings/booking/Booking.vue'),
  },
]
